export const selectLists = state => state.lists ? state.lists.data : null

export const selectFetchingLists = state => state.lists ? state.lists.fetching : false
